import Cookies from 'js-cookie';

export default class GeoAccept {
  constructor($c) {
    this.$c = $c.jquery ? $c.get(0) : $c;
    this.opts = {
      cookieName: this.$c.dataset.geoAcceptCookieName,
      trueValue: this.$c.dataset.geoAcceptCookieTrueValue,
      httpHost: this.$c.dataset.geoAcceptCookieHttpHost,
      expiresDays: this.$c.dataset.geoAcceptCookieExpiresDays,
    };

    this.$c.addEventListener('click', () => this.clickHandler());

    this.clickHandler = () => {
      Cookies.set(
        this.opts.cookieName,
        this.opts.trueValue,
        {
          expires: this.opts.expiresDays,
          path: '/',
          domain: this.opts.httpHost,
        },
      );
    };
  }
}
